import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import {
  $applicationDocumentTypeOptions,
  $countryOptions,
  $cryptoCurrencyOptions,
  $currencyOptions,
  $docTypesOptions,
  $error,
  $isLoading,
  $organizationDocumentTypeOptions,
  dictionariesRequested,
} from '../model';

export const usedictionaries = () => {
  const {
    docTypesOptions,
    currencyOptions,
    cryptoCurrencyOptions,
    countryOptions,
    applicationDocumentTypeOptions,
    organizationDocumentTypeOptions,
    isLoading,
    error,
    request,
  } = useUnit({
    docTypesOptions: $docTypesOptions,
    currencyOptions: $currencyOptions,
    cryptoCurrencyOptions: $cryptoCurrencyOptions,
    countryOptions: $countryOptions,
    applicationDocumentTypeOptions: $applicationDocumentTypeOptions,
    organizationDocumentTypeOptions: $organizationDocumentTypeOptions,
    isLoading: $isLoading,
    error: $error,
    request: dictionariesRequested,
  });

  useEffect(() => {
    if (docTypesOptions.length) return;
    request();
  }, [docTypesOptions.length, request]);

  return {
    docTypesOptions,
    currencyOptions,
    cryptoCurrencyOptions,
    countryOptions,
    applicationDocumentTypeOptions,
    organizationDocumentTypeOptions,
    isLoading,
    error,
    reload: request,
  };
};
